import type {
  ChannelTab,
  SessionFilterOption,
  GranularityOption,
} from "./types"

export const CUBE_NAME = "company_web_analytics_journey_analysis"

export const CHANNEL_TAB_OPTIONS: { id: ChannelTab; label: string }[] = [
  { id: "total", label: "Total" },
  { id: "baseline", label: "Baseline" },
  { id: "triggered", label: "Triggered" },
  { id: "paid", label: "Paid" },
]

export { TRIGGERED_PATTERNS, SOCIAL_REFERRAL_SOURCES } from "../constants"

export const SESSION_FILTER_OPTIONS: {
  value: SessionFilterOption
  label: string
}[] = [
  { value: "all", label: "All Sessions" },
  { value: "with_purchases", label: "With Purchases" },
  { value: "with_adds_to_cart", label: "With Adds to Cart" },
]

export const GRANULARITY_OPTIONS: {
  value: GranularityOption
  label: string
}[] = [
  { value: "all_pages", label: "All Pageviews" },
  { value: "shopping_pages", label: "Shopping Pages" },
  { value: "collection_pages", label: "Collection Pages" },
  { value: "product_pages", label: "Product Pages" },
]

export const CHANNEL_DISPLAY_NAMES: Record<ChannelTab, string> = {
  total: "Total",
  baseline: "Baseline",
  triggered: "Triggered",
  paid: "Paid",
}

export const MAX_NODES_PER_STEP = 15
export const MAX_STEPS = 3
